import React from 'react'
import PropTypes from 'prop-types'
import { default as dayjs } from 'dayjs'

import { useGetMutateCall } from '../../lib/api/get'

export const AttendanceAudit = ({
  isLocalEnvironment,
  auditData,
  auditReportClose,
  isStaffAttendance,
}) => {
  const getCallMutation = useGetMutateCall()
  const [reportData, setReportData] = React.useState(null)

  React.useEffect(() => {
    const close = (e) => {
      if (e.keyCode === 27) {
        auditReportClose(false)
      }
    }
    window.addEventListener('keydown', close)
    return () => window.removeEventListener('keydown', close)
  }, [])

  const getData = async () => {
    await getCallMutation
      .mutateAsync({
        apiURL: isLocalEnvironment + '/getData',
        apiEndpoint: isStaffAttendance ? 'staffAttendance/audit' : 'attendance/audit',
        id: isStaffAttendance ? auditData.staffAttendanceId : auditData.attendanceId,
        params: '',
      })
      .then((resp) => setReportData(resp.formData))
      .catch((err) => console.log(err))
  }
  React.useEffect(() => {
    getData()
  }, [])

  const actionDetails = (action, auditType, auditDateTime) => {
    let res
    if (typeof action === 'object') {
      if (auditType === 'Update' && (action !== null || action !== '')) {
        if (action === null) {
          res = 'Null'
        } else {
          Object.entries(action).map((act) => {
            const actVal = JSON.parse(act[1])
            if (act[0] === 'checkInDateTime') {
              res =
                'updated Check-In time from ' +
                (actVal.oldValue ? dayjs(actVal.oldValue).format('MMM DD YYYY HH:mm:ss') : '""') +
                ' - ' +
                (actVal.newValue ? dayjs(actVal.newValue).format('MMM DD YYYY HH:mm:ss') : '""')
            }
            if (act[0] === 'checkInConfirmedDateTime') {
              res =
                'updated Check-In confirmed time from ' +
                (actVal.oldValue ? dayjs(actVal.oldValue).format('MMM DD YYYY HH:mm:ss') : '""') +
                ' - ' +
                (actVal.newValue ? dayjs(actVal.newValue).format('MMM DD YYYY HH:mm:ss') : '""')
            }
            if (act[0] === 'checkOutDateTime') {
              res =
                'updated Check-Out time from ' +
                (actVal.oldValue ? dayjs(actVal.oldValue).format('MMM DD YYYY HH:mm:ss') : '""') +
                ' - ' +
                (actVal.newValue ? dayjs(actVal.newValue).format('MMM DD YYYY HH:mm:ss') : '""')
            }
            if (act[0] === 'checkOutConfirmedDateTime') {
              res =
                'updated Check-Out confirmed time from ' +
                (actVal.oldValue ? dayjs(actVal.oldValue).format('MMM DD YYYY HH:mm:ss') : '""') +
                ' - ' +
                (actVal.newValue ? dayjs(actVal.newValue).format('MMM DD YYYY HH:mm:ss') : '""')
            }
          })
        }
      }
    } else if (auditType === 'Create') {
      res = 'Created attendance at ' + dayjs(auditDateTime).format('MMM DD YYYY HH:mm:ss')
    } else if (auditType === 'Delete') {
      res = 'Deleted attendance at ' + dayjs(auditDateTime).format('MMM DD YYYY HH:mm:ss')
    }
    return res
  }

  return (
    <div
      className="trtui-modal trtui-modal-xl trtui-fade trtui-show"
      aria-labelledby="exampleModalLabel"
      style={{ display: 'block', backgroundColor: 'rgba(55,55,55,0.3)' }}
      aria-modal="true"
      role="dialog"
    >
      <div className="trtui-modal-dialog trtui-modal-dialog-scrollable trtui-modal-xl">
        <div className="trtui-modal-content">
          <div className="trtui-modal-header trtui-bg-light trtui-p-3">
            <h5 className="trtui-modal-title" id="exampleModalLabel">
              {isStaffAttendance ? 'Staff' : 'Child'} Attendance History
            </h5>
            <button
              type="button"
              className="trtui-btn-close"
              onClick={() => {
                auditReportClose()
              }}
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="ri-close-line" />
            </button>
          </div>
          <div className="trtui-modal-body">
            <div className="trtui-card">
              <div className="trtui-card-body">
                <div className="trtui-tab-content">
                  <div className={`trtui-tab-pane trtui-active`} role="tabpanel">
                    <div className="trtui-table-responsive trtui-mt-xl-0">
                      <table className="trtui-table trtui-table-white trtui-table-striped trtui-table-nowrap trtui-align-middle trtui-mb-0">
                        <thead>
                          <tr>
                            <th scope="col">Time</th>
                            <th scope="col">User</th>
                            <th scope="col">Action</th>
                            <th scope="col">Details</th>
                          </tr>
                        </thead>
                        <tbody>
                          {reportData !== null && reportData.length > 0 ? (
                            reportData
                              .sort(
                                (a, b) =>
                                  dayjs(a.auditDateTime).format('MMM DD YYYY HH:mm:ss') -
                                  dayjs(b.auditDateTime).format('MMM DD YYYY HH:mm:ss'),
                              )
                              .map((rep, repInd) => (
                                <tr key={repInd}>
                                  <td>{dayjs(rep.auditDateTime).format('MMM DD YYYY HH:mm:ss')}</td>
                                  <td style={{ paddingBottom: '0.1rem', paddingTop: '0.1rem' }}>
                                    <div>
                                      <h5 className="trtui-fs-14 trtui-my-1">
                                        <a href="#!" className="trtui-text-reset">
                                          {rep.userFullName}
                                        </a>
                                      </h5>
                                      <span className="trtui-text-muted">{rep.email}</span>
                                    </div>
                                  </td>
                                  <td>{rep.auditType}</td>
                                  <td>
                                    <p>
                                      {actionDetails(
                                        rep.changedDataSet === ''
                                          ? rep.changedDataSet
                                          : JSON.parse(rep.changedDataSet),
                                        rep.auditType,
                                        rep.auditDateTime,
                                      )}
                                    </p>
                                  </td>
                                </tr>
                              ))
                          ) : (
                            <tr>
                              <td colSpan={4}>No Data</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

AttendanceAudit.propTypes = {
  isLocalEnvironment: PropTypes.string,
  auditData: PropTypes.object,
  auditReportClose: PropTypes.func,
  isStaffAttendance: PropTypes.bool,
}
